module.exports = __webpack_public_path__ + "img/addressEle.7087aa4d.svg";